import { Component } from 'react'

export class Post extends Component {

	constructor( props ) {
		super( props )
	}

	render() {
		return (
			<div className="bi-post col-12 col-md-6 col-lg-4">
				<div className="bi-post__image"><a href={ this.props.post.link } dangerouslySetInnerHTML={{ __html: this.props.post.featured_media_img }} /></div>

				<div className="bi-post__text">
					<div className="bi-post__category">{ this.props.post.category_name }</div>
					<h3 className="bi-post__title"><a href={ this.props.post.link }>{ this.props.post.title.rendered }</a></h3>

					<div className="bi-post__author">By { this.props.post.author_name }</div>
				</div>
			</div>
		)
	}
}